import UsersSelectroPresenterDefinition from './UsersSelectroPresenterDefinition';
import InitiativesSelectroPresenterDefinition from './InitiativesSelectroPresenterDefinition';
import StrategicImperativesSelectroPresenterDefinition from './StrategicImperativesSelectroPresenterDefinition';
import IdeasSelectroPresenterDefinition from './IdeasSelectroPresenterDefinition';
import FeaturesSelectroPresenterDefinition from './FeaturesSelectroPresenterDefinition';

// Singleton instance of the UsersSelectroPresenterDefinition
export const UsersSelectroPresenter =
  UsersSelectroPresenterDefinition.getInstance();

// Singleton instance of the InitiativesSelectroPresenterDefinition
export const InitiativesSelectroPresenter =
  InitiativesSelectroPresenterDefinition.getInstance();

// Singleton instance of the StrategicImperativesSelectroPresenterDefinition
export const StrategicImperativesSelectroPresenter =
  StrategicImperativesSelectroPresenterDefinition.getInstance();

// Singleton instance of the IdeasSelectroPresenterDefinition
export const IdeasSelectroPresenter =
  IdeasSelectroPresenterDefinition.getInstance();

// Singleton instance of the FeaturesSelectroPresenterDefinition
export const FeaturesSelectroPresenter =
  FeaturesSelectroPresenterDefinition.getInstance();
